/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SectionsProfessionalReferralComponent = {
  id?: number
  __component?: string
  title?: string
  style?: SectionsProfessionalReferralComponent.style
}
export namespace SectionsProfessionalReferralComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
  }
}
